import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/bookmarkAction.svg';

export const IconBookmarkAction = createIconComponent(Icon);
